export default __webpack_public_path__ + "static/media/(12).2746458f.jpeg";